module.exports = ".Editable{border:1px dashed #119CE0;position:relative}\n"